/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useReducer, createContext, useEffect } from 'react'
import moment from 'moment'
import { isEmpty } from 'lodash'
import { FilterProduct } from '../types/FilterProduct'
import { defaultFormatTimeZone } from '../utils/consts'

interface ProductFiltersContextType {
  filters: FilterProduct
  setFilters: (filters: FilterProduct) => any
}
const initialState: ProductFiltersContextType = {
  filters: {
    orderStates: [],
    orderCities: [],
    status: [],
    products: [],
    factory: [],
    createdAt: {
      initialDate: moment().clone().subtract(15, 'days').format('YYYY-MM-DD'),
      finalDate: moment().clone().format('YYYY-MM-DD'),
      ...defaultFormatTimeZone
    }
  },
  setFilters: () => { }
}
const storageItem = 'filters-products-portal-analytics'
let localState: object = {}
if (!isEmpty(sessionStorage.getItem(storageItem))) localState = JSON.parse(sessionStorage.getItem(storageItem) || '{}')

const reducer = (state: any, newState: any) => {
  if (newState === null) {
    sessionStorage.removeItem(storageItem)
    return initialState
  }

  return { ...state, filters: { ...state.filters, ...newState } }
}

export const ProductFiltersContext = createContext(initialState)

const ProductFiltersContextProvider: React.FC = (props: any) => {
  const [filters, setFilters] = useReducer(reducer, !isEmpty(localState) ? localState : initialState)
  useEffect(() => {
    sessionStorage.setItem(storageItem, JSON.stringify(filters))
  }, [filters])

  return (
    <ProductFiltersContext.Provider value={{ ...filters, setFilters }}>
      {props.children}
    </ProductFiltersContext.Provider>)
}

export default ProductFiltersContextProvider
